import { render, staticRenderFns } from "./createCompanyClassificationModal.vue?vue&type=template&id=765b8e10&"
import script from "./createCompanyClassificationModal.vue?vue&type=script&lang=js&"
export * from "./createCompanyClassificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports